<template lang="html">
<div id="buildings">
    <el-row class="headLine">
        <el-col :span="12">栏目管理</el-col>
        <!-- 编辑 -->
        <el-col :span="12" style="text-align:right;">
            <el-button @click="newAdd('new')" size="small" type="primary">新建</el-button>
        </el-col>
    </el-row>
    <Column ref="column" />
</div>
</template>

<script>
import Column from './components/column';
export default {
    components: {
        Column
    },
    data() {
        return {

        }
    },
    methods: {
        newAdd(type) {
            this.$refs.column.addColumn(type);
        },
    }

}
</script>

<style lang="scss" scoped>
#buildings {
    font-size: 15px;
    background-color: #f5f5f5;
    min-height: 500px;

    .headLine {
        padding: 0 20px;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #ebeef5;
        background-color: #fff;

        .headright {
            text-align: right;
            margin-right: 10px;
            display: block;

        }
    }

}

.input {
    width: 240px;
    border-radius: none;
}
</style>

<style lang="css">
#buildings .el-input__inner {
    border-radius: 0px !important;
}
</style>



// WEBPACK FOOTER //
// index.vue?0369d970